import { combineReducers } from "redux";
import user from "./user/userReducer";
import i18n from "./i18n/i18nReducer";
import admin from "./admin/adminReducer";
import company from "./company/companyReducer";
import url from "./authentication/authentication";
import rgpd from "./rgpd/rgpdReducer";

import { LOGOUT } from "../actions/authentication/authentication";

const appReducer = combineReducers({
  user: user,
  admin: admin,
  url: url,
  company: company,
  rgpd: rgpd,
  i18n: i18n,
});

const urlReducer = (state, action) => {
  if (action.type === LOGOUT) {
    // Wipe all redux state
    state = undefined;
  }

  return appReducer(state, action);
};

export default urlReducer;
